<template>
    <v-responsive fluid>
        <v-divider class="test"></v-divider>
        <v-tabs v-model="tab" fixed-tabs center-active>
            <v-tab v-for="item in items" :key="item.tab" class="primary--text">
                {{ item.tab }}
                <v-icon color="primary">{{ item.icon }}</v-icon>
            </v-tab>
        </v-tabs>
        <v-tabs-items v-model="tab">
            <v-tab-item v-for="item in items" :key="item.tab">
                <component :is="item.component"></component>
            </v-tab-item>
        </v-tabs-items>
    </v-responsive>
    <!-- <v-row>
        <v-col md="7">
            <v-row>
                <v-col md="12">
                    <InsuranceManagementTable />
                </v-col>
                <v-col md="12">
                    <ProcedureManagementTable />
                </v-col>
            </v-row>
        </v-col>
        <v-col md="5">
            <v-row>
                <v-col md="12">
                    <ObjectiveTypesManagementTable />
                </v-col>
            </v-row>
            <v-row>
                <v-col md="12">
                    <DBOriginManagementTable />
                </v-col>
            </v-row>
        </v-col>
    </v-row> -->
</template>

<script>
import InsuranceManagementTable from '@/components/GerenciaTeletrabajo/Management/INDBOPROManagement/InsuranceManagement/InsuranceManagementTable.vue';
import ProcedureManagementTable from '@/components/GerenciaTeletrabajo/Management/INDBOPROManagement/ProcedureManagement/ProcedureManagementTable.vue';
import DBOriginManagementTable from '@/components/GerenciaTeletrabajo/Management/INDBOPROManagement/DBOriginManagement/DBOriginManagementTable.vue';
import ObjectiveTypesManagementTable from '@/components/GerenciaTeletrabajo/Management/INDBOPROManagement/ObjectiveTypesManagement/ObjectiveTypesManagementTable.vue';

export default {
    name: 'INDBOPROManagement',
    components: {
        DBOriginManagementTable,
        InsuranceManagementTable,
        ProcedureManagementTable,
        ObjectiveTypesManagementTable,
    },
    data: () => ({
        tab: 0,
        items: [
            {
                tab: 'Seguros',
                icon: 'mdi-tag',
                component: 'InsuranceManagementTable',
            },
            {
                tab: 'Trámites',
                icon: 'mdi-tag-plus',
                component: 'ProcedureManagementTable',
            },
            {
                tab: 'Tipos de Objetivo',
                icon: 'mdi-cart-plus',
                component: 'ObjectiveTypesManagementTable',
            },
            {
                tab: 'Origenes BD',
                icon: 'mdi-sale',
                component: 'DBOriginManagementTable',
            },
        ],
    }),
    methods: {},
};
</script>
<style lang="scss">
.v-slide-group__prev {
    display: none !important;
}
</style>
